module.exports = __webpack_public_path__ + "img/bollitore.e022e566.jpeg";